import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { MobileDocumentCustomizationModal } from './components/MobileDocumentCustomizationModal'
import { DesktopDocumentCustomizationModal } from './DocumentCustomizationModal'
import { DocumentCustomizationModalProps } from './types'

export const DocumentCustomizationModalSwitcher = (props: DocumentCustomizationModalProps) => {
  const { isAboveTablet } = useMediaQueries()
  return isAboveTablet ? (
    <DesktopDocumentCustomizationModal {...props} />
  ) : (
    <MobileDocumentCustomizationModal {...props} />
  )
}
